import { useGetFile, useUploadFileMutation } from "@hooks";
import { FileUploadElement, StepValue } from "@types";
import { getFilenameFromResponse } from "@utils";
import { useParams } from "react-router-dom";
import UploadContainer from "src/components/Form/Elements/UploadContainer";

const FileUpload = ({
  element,
  answerFileId,
  onChange,
}: {
  element: FileUploadElement;
  answerFileId: string | undefined | null;
  onChange: (id: string, value: StepValue) => void;
}) => {
  const { orgId = "" } = useParams();
  const { data: file, isLoading: isLoadingFile } = useGetFile({
    orgId,
    fileId: answerFileId || "",
  });

  const uploadFileMutation = useUploadFileMutation();

  const filename = getFilenameFromResponse(file);

  const handleChange = async (file: File) => {
    const fileId = await uploadFileMutation.mutateAsync({
      orgId,
      file,
    });

    onChange(element.id, { answerFileId: fileId.id });
    return fileId;
  };

  const handleDeleteFile = () => {
    onChange(element.id, {
      answerFileId: undefined,
    });
  };

  return (
    <UploadContainer
      onChange={handleChange}
      element={element}
      allowedFileTypes={element.options.allowedFileTypes}
      isLoading={isLoadingFile}
      file={file?.data}
      fileId={answerFileId}
      filename={filename}
      onDeleteFile={handleDeleteFile}
    />
  );
};

export default FileUpload;
